import NewsFormInputGroup from './NewsFormInputGroup';

export default NewsFormInputGroup;
